/**
 * Analytics Portal V1 — Business Analytics (Phase 12, plan §4.4 + §11 endpoint 5).
 * A pure renderer of `GET /api/analytics/business` through the shared entity dashboard.
 */
import React from "react";
import { EntityDashboard } from "@/components/analytics/EntityDashboard";
import { NamedVisitorPanel } from "@/components/analytics/NamedVisitorPanel";
import { BUSINESS_GROUPS, BUSINESS_HEADLINE } from "@/components/analytics/businessMetrics";
import { useAnalyticsPortal } from "./AnalyticsPortal";

export default function BusinessTab() {
  const portal = useAnalyticsPortal();
  return (
    <EntityDashboard
      portal={portal}
      testId="analytics-view-business"
      scopeType="business"
      headline={BUSINESS_HEADLINE}
      groups={BUSINESS_GROUPS}
      funnelTitle="Business conversion funnel"
      noActivityBody="This business's analytics will populate once eligible activity is collected."
      afterGroups={portal?.payload && (
        <NamedVisitorPanel entityType="business" entityId={portal.entity}
                           capabilities={portal.payload.capabilities} range={portal.range} />
      )}
    />
  );
}
